(function () {
    /********************* Setup *********************/

    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#product`);

    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    const product = JSON.parse(section.querySelector(".productJSON").textContent);

    // the starting activeVariant is set in the section liquid; on option changes we fetch fresh data
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);

    let charmsToAdd = [];

    // whether the current variant is price-on-request — flagged via the maltertech.show_price_request metafield
    function isPriceRequest() {
        return variantPriceRequest[activeVariant.id] === true;
    }

    // the primary CTA label swaps to a price-request prompt when the active variant is price-on-request
    function getAtcText() {
        let atcText = "Add To Cart";
        if (isPriceRequest()) {
            atcText = "Pricing available upon request";
        }
        return atcText;
    }

    // hide the price for price-on-request variants, show it otherwise
    function updatePriceVisibility() {
        if (isPriceRequest()) {
            section.querySelector("#productPrice").classList.remove("active");
            return;
        }
        section.querySelector("#productPrice").classList.add("active");
    }

    /********************* Preload Variant Images *********************/

    product.variants.forEach(function (variant) {
        if (!variant.featured_image) return;
        const rawSrc = variant.featured_image.src;
        [rawSrc + '&width=800', rawSrc + '&width=1000'].forEach(function (src) {
            new Image().src = src;
        });
    });

    /********************* Adjust Title Size *********************/

    // dynamically shrinks the title to fit just under the container width on mobile
    function adjustFontSize() {
        const container = section.querySelector('#productContent');
        const text = section.querySelector('#productTitle');
        let fontSize = parseFloat(window.getComputedStyle(text).fontSize);

        while (text.offsetWidth >= container.offsetWidth - 48) {
            fontSize -= 1;
            text.style.fontSize = fontSize + 'px';
        }
    }

    if (window.innerWidth < 801) {
        adjustFontSize();
    }

    // change values container to flex if overflow is detected on desktop
    if (window.innerWidth > 801) {
        const container = section.querySelector('#productInner');
        const containerWidth = container.offsetWidth * 0.35;

        section.querySelectorAll('.productOptionItemValues').forEach(function (element) {
            if (element.offsetWidth > containerWidth) {
                element.classList.add('flex');
            }
        });
    }

    /********************* Gallery *********************/

    section.querySelectorAll(".productInnerVisualDropdownBtn").forEach(element => {
        element.addEventListener("click", function () {
            section.querySelector('.productInnerVisualDropdownBottom').classList.toggle("active");
            this.classList.toggle("active");
            section.querySelector('.productInnerVisualDropdownBtnTxt').textContent = this.classList.contains("active") ? "Show Less" : "Show More";
        });
    });

    // mobile swiper — Swiper owns swiping; only nearby slides are decoded so 60+ image
    // galleries don't exhaust mobile Safari's renderer memory. Zoom is delegated to a single
    // MagicZoom stage (see tap handler below) so only one big image is ever loaded.
    const productSwiper = new Swiper('#productInnerVisualSwiper', {
        slidesPerView: 1,
        spaceBetween: 10,
        lazyPreloadPrevNext: 1,
        on: {
            slideChange: function () {
                // pause all videos and restore play icons when slide changes
                section.querySelectorAll('#productInnerVisualSwiper video').forEach(video => {
                    video.pause();
                    video.closest('.productInnerVisualSwiperItemVideoBtn')
                        ?.querySelector('.productInnerVisualGridVideoPlay')
                        ?.classList.remove('active');
                });
            }
        }
    });

    /********************* Mobile Tap-To-Zoom *********************/

        // a single hidden MagicZoom gallery (stage + one selector per image) drives mobile fullscreen
        // zoom, so the expanded view can swipe between images and only loads images on demand.
        // MagicZoom.expand() silently bails while the target image is still loading, so we attempt the
        // open and (re)open it from MagicZoom's load callbacks once the image is ready.
    const ZOOM_STAGE_ID = 'productInnerVisualZoomStage';
    const zoomSelectors = section.querySelectorAll('.productInnerVisualZoomSelectorsItem');
    let zoomPending = false;

    function expandZoomIfPending(id) {
        if (id !== ZOOM_STAGE_ID || !zoomPending) {
            return;
        }
        zoomPending = false;
        MagicZoom.expand(ZOOM_STAGE_ID);
    }

    // MagicZoom injects decorative overlay imgs (a transparent placeholder gif) into the lens and
    // zoom-window, none with an alt — mark them decorative so they don't fail accessibility audits.
    // The zoom-window is appended at document level, so query the whole document, not just section
    function hideZoomOverlaysFromAssistiveTech() {
        document.querySelectorAll('.mz-lens img, .mz-zoom-window img').forEach(overlayImg => {
            overlayImg.setAttribute('alt', '');
            overlayImg.setAttribute('aria-hidden', 'true');
        });
    }

    // onUpdate fires after a swapped image loads, onZoomReady after a lazy image becomes ready —
    // either means the target is now loaded and expand() will succeed. onZoomReady also means the
    // lens/zoom-window overlays now exist, so mark them decorative here too
    MagicZoom.registerCallback('onUpdate', expandZoomIfPending);
    MagicZoom.registerCallback('onZoomReady', function (id) {
        expandZoomIfPending(id);
        hideZoomOverlaysFromAssistiveTech();
    });
    // once it actually opens, stop retrying and mark the fullscreen zoom-window overlay decorative
    MagicZoom.registerCallback('onExpandOpen', function (id) {
        if (id === ZOOM_STAGE_ID) {
            zoomPending = false;
        }
        hideZoomOverlaysFromAssistiveTech();
    });

    // open the gallery at a given image index — always sync to the right image first (a no-op if
    // it's already current), then attempt expand; the callbacks above open it once it has loaded
    function openZoom(index) {
        zoomPending = true;
        MagicZoom.switchTo(ZOOM_STAGE_ID, index);
        MagicZoom.expand(ZOOM_STAGE_ID);
    }

    // tap a slide to open fullscreen zoom — Swiper suppresses this click after a swipe, so it only
    // fires on a genuine tap (not while swiping). Video slides have no zoom index and are ignored.
    productSwiper.on('click', function (swiper) {
        const slide = swiper.clickedSlide;
        if (!slide || slide.dataset.zoomIndex === undefined) {
            return;
        }
        openZoom(parseInt(slide.dataset.zoomIndex, 10));
    });

    // warm the current image's large file once a swipe settles so opening zoom feels instant
    productSwiper.on('slideChangeTransitionEnd', function (swiper) {
        const index = swiper.slides[swiper.activeIndex]?.dataset.zoomIndex;
        if (index === undefined) {
            return;
        }
        const selector = zoomSelectors[parseInt(index, 10)];
        if (selector) {
            new Image().src = selector.getAttribute('href');
        }
    });

    // click-to-play for all video blocks (grid + swiper)
    section.querySelectorAll('.productInnerVisualGridWrapVideo, .productInnerVisualSwiperItemVideoBtn').forEach(element => {
        element.addEventListener('click', function () {
            const video = this.querySelector('video');
            const playIcon = this.querySelector('.productInnerVisualGridVideoPlay');
            if (!video) return;

            // pause all other playing videos
            section.querySelectorAll('.productInnerVisualGridWrapVideo video, .productInnerVisualSwiperItemVideoBtn video').forEach(otherVideo => {
                if (otherVideo !== video && !otherVideo.paused) {
                    otherVideo.pause();
                    otherVideo.closest('.productInnerVisualGridWrapVideo, .productInnerVisualSwiperItemVideoBtn')
                        ?.querySelector('.productInnerVisualGridVideoPlay')
                        ?.classList.remove('active');
                }
            });

            if (video.paused) {
                video.play();
                playIcon?.classList.add('active');
            } else {
                video.pause();
                playIcon?.classList.remove('active');
            }
        });
    });

    /********************* Description Expand *********************/

    section.querySelector("#productDescMore").addEventListener("click", function () {
        this.classList.toggle("active");

        if (this.classList.contains("active")) {
            this.textContent = "Read More";
            section.querySelector("#productDescShort").classList.add("active");
            section.querySelector("#productDescLong").classList.remove("active");
        } else {
            section.querySelector("#productDescShort").classList.remove("active");
            section.querySelector("#productDescLong").classList.add("active");
            this.textContent = "Read Less";
        }
    });

    /********************* Unchecked Options Tracking *********************/

        // collect unique input group names — all are unchecked on load
    const radios = new Set();
    const inputs = section.querySelectorAll(".productOption select, input");

    inputs.forEach(function (radioButton) {
        if (radioButton.closest('send-a-hint')) {
            return;
        }
        if (radioButton.type === "text") {
            return;
        }
        radios.add(radioButton.name);
    });

    const uncheckedOptions = Array.from(radios);

    // remove any options that are already selected/checked on load
    inputs.forEach(function (radioButton) {
        const alreadySelected = (radioButton.tagName === 'SELECT' && radioButton.value !== 'Please select an option') || radioButton.checked;
        if (!alreadySelected) {
            return;
        }
        const indexToRemove = uncheckedOptions.indexOf(radioButton.name);
        if (indexToRemove !== -1) {
            uncheckedOptions.splice(indexToRemove, 1);
        }
    });

    /********************* Product Variants *********************/

    let quantity = 1;
    let mergedProduct;
    let mergedActiveVariant;

    section.querySelectorAll("select, input").forEach(function (element) {
        element.addEventListener("change", function () {
            const indexToRemove = uncheckedOptions.indexOf(this.name);
            if (indexToRemove !== -1) {
                uncheckedOptions.splice(indexToRemove, 1);
            }

            updateProduct(this.dataset.target);

            // hide error message for this target if shown
            const target = this.dataset.target;
            const targetElement = section.querySelector(`[data-target="${CSS.escape(target)}"]`);
            if (targetElement) {
                targetElement.classList.remove("active");
            }
        });
    });

    // run once on load so the initial variant state is correct
    // skipImageUpdate=true so the default grid image stays visible
    updateProduct(undefined, undefined, true, true);

    async function getActiveVariant(product, container) {
        if (defaultOnly) {
            return product.variants.find((variant) => {
                return variant.id === product.variants[0].id;
            });
        }

        const options = [];

        container.querySelectorAll(`input.productOptionColorRadio:checked`).forEach(element => {
            options.push(element.dataset.id);
        });

        container.querySelectorAll('.productOptionItemSelect').forEach(element => {
            const selectedOption = element.options[element.selectedIndex];
            options.push(selectedOption.dataset.id);
        });

        container.querySelectorAll('.productOptionSelect').forEach(element => {
            const selectedOption = element.options[element.selectedIndex];
            options.push(selectedOption.dataset.id);
        });

        const response = await fetch(`/products/${product.handle}?view=active-variant&option_values=${options.join(',')}`)
            .then(response => response.json());

        return response.active_variant;
    }

    /**
     * Klaviyo track viewed product
     * @param status - inventory status
     * @param product - product object
     * @param activeVariant - active variant object
     */
    function buildTrackPayload(status, product, activeVariant) {
        // build the image url, falling back to the product's first image
        const imageURL = "https:" + (activeVariant.featured_image ? activeVariant.featured_image.src : product.images[0]);

        // fall back to the product title when the variant has no real title
        let variantTitle = activeVariant.title;
        if (variantTitle === "Default Title") {
            variantTitle = product.title;
        }

        return {
            in_stock: status.on_hand_minus_committed_inventory > 0,
            in_stock_quantity: status.on_hand_minus_committed_inventory,
            lead_time_days: status.lead_time_days,
            product_title: product.title,
            variant_title: variantTitle,
            image_url: imageURL,
            price: price(activeVariant.price),
            url: `https://www.audryrosejewelry.com/products/${product.handle}`,
        };
    }

    function trackView(status, product, activeVariant) {
        try {
            klaviyo.push(["track", "Viewed Product | MalterTech", buildTrackPayload(status, product, activeVariant)]);
        } catch (error) {
            console.log(error);
        }
    }

    function trackAddToCart(status, product, activeVariant) {
        try {
            klaviyo.push(["track", "Add to Cart | MalterTech", buildTrackPayload(status, product, activeVariant)]);
        } catch (error) {
            console.log(error);
        }
    }


    async function updateProduct(target, wrapper, skipImageUpdate = false, skipUpdateInventory = false) {

        // default-only product: just check stock and update price
        if (defaultOnly) {
            const status = await getInventoryStatus(product.variants[0].sku);
            trackView(status, product, product.variants[0]);

            if (!status.sold_out && !status.error) {
                section.querySelector("#productATC").disabled = false;
                section.querySelector("#productATC").textContent = getAtcText();
                section.querySelector("#productBottomAtc").textContent = getAtcText();
            } else {
                section.querySelector("#productATC").disabled = true;
                section.querySelector("#productATC").textContent = "Sold Out";
            }

            section.querySelector("#productPrice").textContent = price(activeVariant.price * quantity, true);
            updatePriceVisibility();
            if (activeVariant.compare_at_price > activeVariant.price) {
                section.querySelector("#productCompare").classList.add("active");
                section.querySelector("#productCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
            } else {
                section.querySelector("#productCompare").classList.remove("active");
            }
            section.querySelector("#productTermsPrice").textContent = price((activeVariant.price * quantity) / 12);
            return;
        }

        // update option labels to reflect selected values
        section.querySelectorAll(`input.productOptionColorRadio:checked`).forEach(element => {
            section.querySelector('.productOptionColorTitle').innerHTML = element.value;
        });

        section.querySelectorAll('.productOption select').forEach(element => {
            const titleEl = element.closest('.productOption')?.querySelector('.productOptionTitle');
            if (titleEl && element.value !== 'Please select an option') titleEl.innerHTML = element.value;
        });

        const escapedTarget = CSS.escape(target);
        section.querySelectorAll(`[data-target="${escapedTarget}"].productOptionDropBodyRadioInput:checked`).forEach(element => {
            section.querySelector(`[id="${escapedTarget}"].productOptionDropTitleChoice`).innerHTML = element.value;
        });

        const optionsContainer = section.querySelector(".productWrap.normal");
        activeVariant = await getActiveVariant(product, optionsContainer);

        if (!activeVariant) {
            if (uncheckedOptions.length === 0) {
                section.querySelector("#productATC").textContent = "Sold Out";
                section.querySelector("#productATC").classList.add("disabled");
                return;
            }

            const unselectOption = uncheckedOptions[0];
            section.querySelector("#productATC").textContent = `Please Select a ${unselectOption}`;
            section.querySelector("#productATC").classList.add("disabled");
            return;
        }

        section.querySelector("#productATC").classList.remove("disabled");

        // update first image to match the active variant's featured image
        if (activeVariant.featured_image && !skipImageUpdate) {
            const rawSrc = activeVariant.featured_image.src;

            const firstGridWrap = section.querySelector("a.productInnerVisualGridWrap.MagicZoom");
            MagicZoom.update(firstGridWrap.id, rawSrc + '&width=1000', rawSrc + '&width=800');
            if (!firstGridWrap.dataset.galleryBlocked) {
                ['mousedown', 'click'].forEach(function (type) {
                    firstGridWrap.addEventListener(type, function (e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                    }, true);
                });
                firstGridWrap.dataset.galleryBlocked = '1';
            }

            // the mobile swiper deliberately leaves variant images out of its slides, so mirror the
            // grid: swap the first image slide's source to the variant image and jump back to it
            const firstSwiperSlide = section.querySelector("#productInnerVisualSwiper .swiper-slide[data-zoom-index]");
            if (firstSwiperSlide) {
                firstSwiperSlide.querySelector(".productInnerVisualSwiperItemImg").src = rawSrc + '&width=800';

                // repoint tap-to-zoom at the variant image's spot in the image-only zoom gallery
                const zoomImages = product.media.filter(media => media.media_type === 'image');
                const zoomIndex = zoomImages.findIndex(media => media.id === activeVariant.featured_media?.id);
                if (zoomIndex !== -1) {
                    firstSwiperSlide.dataset.zoomIndex = zoomIndex;
                }

                productSwiper.slideTo(Array.from(productSwiper.slides).indexOf(firstSwiperSlide));
            }
        }

        // special developer_only sale styling
        if (product.tags.includes('developer_only') && activeVariant.compare_at_price > activeVariant.price) {
            section.querySelector('#productPrice').classList.add('sale');
            section.querySelector('#productSave').classList.add('active');

            const save = ((activeVariant.compare_at_price - activeVariant.price) / activeVariant.compare_at_price) * 100;
            section.querySelector('#productSave').textContent = `LIMITED TIME OFFER - SAVE  ${save.toFixed(0)}%`;
        } else {
            section.querySelector('#productPrice').classList.remove('sale');
            section.querySelector('#productSave').classList.remove('active');
        }

        // Update inventory status
        if (product.variants.length === 1) {
            section.querySelector("#productInventoryStatus").setAttribute("data-sku", activeVariant.sku);

        } else if (!skipUpdateInventory) {
            section.querySelector("#productInventoryStatus").setAttribute("data-sku", activeVariant.sku);
        }

        section.querySelector("#productHint").setAttribute("data-variant-id", activeVariant.id);

        const status = await getInventoryStatus(activeVariant.sku);

        if (!status.sold_out && !status.error) {
            section.querySelector("#productATC").disabled = false;
            section.querySelector("#productATC").textContent = getAtcText();
            section.querySelector("#productBottomAtc").textContent = getAtcText();
        } else {
            section.querySelector("#productATC").disabled = true;
            section.querySelector("#productATC").textContent = "Sold Out";
        }

        trackView(status, product, activeVariant);


        // fetch all additional charm variants concurrently
        const fetchPromises = [];
        let charmsPrice = 0;
        charmsToAdd = [];

        section.querySelectorAll(".productCharms:not(.active) .productCharmsBottomWrapContent").forEach(element => {
            let charmsSelected = false;

            if (element.closest('.productCharmsBottom').classList.contains("active")) {
                const selectedChecks = [];
                element.querySelectorAll("select").forEach((select) => {
                    if (select.value === "Please select an option") {
                        selectedChecks.push(false);
                        section.querySelector('#productATC').textContent = "Please Select an Option";
                        section.querySelector("#productATC").classList.add("disabled");
                    } else {
                        selectedChecks.push(true);
                    }
                });

                if (selectedChecks.every(Boolean)) {
                    charmsSelected = true;
                }
            }

            if (!charmsSelected) {
                return;
            }

            // use the first chain/style option so we don't charge for another chain
            let firstOption = section.querySelector(`.productOption[data-copy="Style"] select option:nth-child(2)`)?.dataset.id;

            if (!firstOption) {
                firstOption = section.querySelector(`.productOption[data-copy="Chain"] select option:nth-child(2)`)?.dataset.id;
            }

            const charmOptions = [];
            if (firstOption) {
                charmOptions.push(firstOption);
            }

            // check for Size option
            let sizeOption = section.querySelector(`.productOption[data-copy="Size"]`) || false;

            // if there is a size option, we need to use the selected value they used for size when finding the new charm variant
            if (sizeOption) {
                const sizeSelect = sizeOption.querySelector("select");
                if (sizeSelect && sizeSelect.value !== "Please select an option") {
                    const selectedSizeOption = sizeSelect.options[sizeSelect.selectedIndex];
                    if (selectedSizeOption?.dataset.id) {
                        charmOptions.push(selectedSizeOption.dataset.id);
                    }
                }
            }

            element.querySelectorAll("select").forEach((select) => {
                const selectedOption = select.options[select.selectedIndex];
                charmOptions.push(selectedOption.dataset.id);
            });

            fetchPromises.push(
                fetch(`/products/${product.handle}?view=active-variant&option_values=${charmOptions.join(',')}`)
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (data) {
                        const charmVariant = data.active_variant;
                        charmsToAdd.push(charmVariant);
                        charmsPrice += charmVariant.price;
                        return charmVariant;
                    })
            );
        });

        if (fetchPromises.length > 0) {
            await Promise.all(fetchPromises);
        }

        // update price
        section.querySelector("#productPrice").textContent = price(activeVariant.price * quantity, true);
        updatePriceVisibility();
        if (activeVariant.compare_at_price > activeVariant.price) {
            section.querySelector("#productCompare").classList.add("active");
            section.querySelector("#productCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
        } else {
            section.querySelector("#productCompare").classList.remove("active");
        }
        section.querySelector("#productTermsPrice").textContent = price((activeVariant.price * quantity) / 12, true);

        // update price to include charm totals
        if (charmsPrice > 0) {
            section.querySelector("#productPrice").textContent = price((activeVariant.price * quantity) + charmsPrice, true);
            if (activeVariant.compare_at_price > activeVariant.price) {
                section.querySelector("#productCompare").classList.add("active");
                section.querySelector("#productCompare").textContent = price((activeVariant.compare_at_price * quantity) + charmsPrice, true);
            } else {
                section.querySelector("#productCompare").classList.remove("active");
            }
            section.querySelector("#productTermsPrice").textContent = price(((activeVariant.price * quantity) + charmsPrice) / 12);

            if (product.tags.includes('developer_only') && activeVariant.compare_at_price > activeVariant.price) {
                section.querySelector('#productPrice').classList.add('sale');
                section.querySelector('#productSave').classList.add('active');

                const charmsCompare = (activeVariant.compare_at_price * quantity) + charmsPrice;
                const save = ((charmsCompare - (activeVariant.price * quantity) - charmsPrice) / charmsCompare) * 100;
                section.querySelector('#productSave').textContent = ` LIMITED TIME OFFER - SAVE ${save.toFixed(0)}%`;
            } else {
                section.querySelector('#productPrice').classList.remove('sale');
                section.querySelector('#productSave').classList.remove('active');
            }
        }

        // check for merged variants — treat as a required upsell
        const mergedVariantsExist = section.querySelector('.productWrap.merged') || false;
        if (!mergedVariantsExist) {
            return;
        }

        mergedProduct = JSON.parse(section.querySelector('.productWrap.merged').dataset.product);
        const mergedVariantContainer = section.querySelector('.productWrap.merged');

        const mergedStatus = await getInventoryStatus(mergedProduct.variants[0].sku);
        if (mergedStatus.sold_out || mergedStatus.error) {
            section.querySelector("#productATC").disabled = true;
            section.querySelector("#productATC").textContent = "Sold Out";
            return;
        }

        mergedActiveVariant = await getActiveVariant(mergedProduct, mergedVariantContainer);

        if (!mergedActiveVariant) {
            if (uncheckedOptions.length === 0) {
                section.querySelector("#productATC").textContent = "Sold Out";
                section.querySelector("#productATC").classList.add("disabled");
                return;
            }

            const unselectOption = uncheckedOptions[0];
            section.querySelector("#productATC").textContent = `Please Select a ${unselectOption}`;
            section.querySelector("#productATC").classList.add("disabled");
            return;
        }

        section.querySelector("#productATC").classList.remove("disabled");

        // update price with merged product
        const totalPrice = (activeVariant.price * quantity) + (mergedActiveVariant.price * quantity) + charmsPrice;
        const totalComparePrice = (activeVariant.compare_at_price * quantity) + (mergedActiveVariant.compare_at_price * quantity) + charmsPrice;

        section.querySelector("#productPrice").textContent = price(totalPrice, true);
        if (totalComparePrice > totalPrice) {
            section.querySelector("#productCompare").classList.add("active");
            section.querySelector("#productCompare").textContent = price(totalComparePrice, true);
        } else {
            section.querySelector("#productCompare").classList.remove("active");
        }
        section.querySelector("#productTermsPrice").textContent = price((totalPrice) / 12);
    }

    /********************* Additional Charms *********************/

    section.querySelectorAll(".productCharmsTop").forEach((dropdown) => {
        dropdown.addEventListener("click", function () {
            dropdown.parentElement.querySelector('.productCharmsBottom').classList.toggle("active");
            dropdown.parentElement.querySelector('.productCharmsTopBox').classList.toggle("active");

            const currentExtrasChecked = section.querySelectorAll('.productCharmsTopBox.active').length;

            // only show one more row than currently checked
            section.querySelectorAll('.productCharms').forEach((el, index) => {
                if (index <= currentExtrasChecked) {
                    el.classList.remove('active');
                } else {
                    el.classList.add("active");
                }
            });

            updateProduct();
        });
    });

    /********************* Product Quantity *********************/

    section.querySelector("#productControlsQtyMinus").addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector("#productControlsQtyValue").textContent = quantity;
        updateProduct();
    });

    section.querySelector("#productControlsQtyPlus").addEventListener("click", function () {
        quantity++;
        section.querySelector("#productControlsQtyValue").textContent = quantity;
        updateProduct();
    });

    /********************* Add To Cart *********************/

    section.querySelector("#productATC").addEventListener("click", async function (e) {
        e.preventDefault();

        // show error for first unchecked option and block checkout
        if (uncheckedOptions.length > 0) {

            const element = section.querySelector(`[data-target="${CSS.escape(uncheckedOptions[0])}"]`);
            element.innerText = "Please Select an Option";
            element.classList.add("active");
            return;
        }

        // block checkout if any open charm selects are unset
        const hasUnselectedCharm = Array.from(section.querySelectorAll(".productCharmsBottom.active select")).some(el => el.value === "Please select an option");
        if (hasUnselectedCharm) {
            return;
        }

        const optionsContainer = section.querySelector(".productWrap.normal");
        activeVariant = await getActiveVariant(product, optionsContainer);
        if (!activeVariant) {
            return;
        }

        // price-on-request variants open the pricing modal instead of adding to cart
        if (isPriceRequest()) {
            this.classList.add("loading");
            await openPricing();
            this.classList.remove("loading");
            return;
        }

        const mergedVariantsExist = section.querySelector('.productWrap.merged') || false;
        if (mergedVariantsExist && !mergedActiveVariant) {
            return;
        }

        this.classList.add("loading");

        const formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // attach engraving property if applicable
        const engravingElement = section.querySelector(".productEngravingInput") || false;
        if (engravingElement) {
            const engravingValue = engravingElement.value.trim();
            if (engravingValue && activeVariant.options.some(option => option.toLowerCase() === "engraved")) {
                formData.items[0].properties = {
                    "Engraving": engravingValue
                };
            }
        }

        // attach any hidden property inputs to the cart item
        const regex = /\[(.*?)\]/g;
        section.querySelectorAll("input[name^='properties']").forEach((property) => {
            const match = property.name.match(regex);
            const propertyName = match ? match[0].replace(/[\[\]]/g, '') : null;
            if (!propertyName) {
                return;
            }
            if (!formData.items[0].hasOwnProperty('properties')) {
                formData.items[0].properties = {};
            }
            formData.items[0].properties[propertyName] = property.value;
        });

        const response = await addProduct(formData);
        if (response.status === 422) {
            alert(response.message);
            this.classList.remove("loading");
            return;
        } else {
            cart = response;
        }

        // track the add to cart with the same payload as the view event
        const atcStatus = await getInventoryStatus(activeVariant.sku);
        trackAddToCart(atcStatus, product, activeVariant);

        // add any extra charms to cart
        if (charmsToAdd.length > 0) {
            const charmsFormData = {
                items: []
            };

            charmsToAdd.forEach((charm) => {
                charmsFormData.items.push({
                    quantity: 1,
                    id: charm.id,
                });
            });

            await addProduct(charmsFormData);
        }

        // add merged product to cart
        if (mergedVariantsExist) {
            // skip if the selected merged option has the skipATC class
            const mergedSelect = section.querySelector('.productWrap.merged select');
            const skipATC = mergedSelect?.options[mergedSelect?.selectedIndex]?.classList.contains('skipATC');

            const mergedFormData = {
                items: [{
                    quantity: 1,
                    id: mergedActiveVariant.id,
                }]
            };

            if (!skipATC) {
                await addProduct(mergedFormData);
            }
        }

        // add ring sizer to cart if customer doesn't know their size
        if (Array.from(section.querySelectorAll('.productOption select')).some(el => el.value === "I don't know my size")) {
            const ringSizerID = 43470089289911;

            const ringSizerFormData = {
                items: [{
                    quantity: 1,
                    id: ringSizerID
                }]
            };
            await addProduct(ringSizerFormData);
        }

        this.classList.remove("loading");
        await openCart();
    });

    /********************* Info Dropdowns *********************/

    section.querySelectorAll('.productInfoItemTitle').forEach(function (element) {
        element.addEventListener("click", function () {
            this.parentElement.classList.toggle("active");
        });
    });

    section.querySelectorAll('.dropdown').forEach(function (element) {
        element.addEventListener("click", function () {
            this.parentElement.classList.toggle("active");
        });
    });

    /********************* Reviews Widget *********************/

    // hide the widget if this product has 0 reviews
    fetch("https://stamped.io/api/widget/badges", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            productIds: [{productId: product.id}],
            apiKey: 'pubkey-3y7z7Mj8g3kwpV6595G40TUUcv8b5D',
            storeUrl: 'loveaudryrose-com.myshopify.com',
        }),
    })
        .then(response => response.json())
        .then(response => {
            if (response[0].count === 0) {
                document.querySelector("#stamped-main-widget").classList.add("active");
            }
        });

    /********************* Dynamic Option Dropdowns *********************/

    if (uncheckedOptions.length === 1) {
        section.querySelectorAll('select.productOptionItem option').forEach(element => {
            const variantId = product.variants.find((id) => {
                return JSON.stringify(id.options[0]) === JSON.stringify(element.value);
            });
        });
    }

    section.querySelector("#productWishlist").addEventListener("click", function () {
        section.querySelector(".productWishTxt").textContent = "";
    });

    /********************* Product Bottom (Mobile) *********************/

    if (window.innerWidth < 800) {
        let isVisible = false;
        const productBottom = section.querySelector('#productBottom');
        const productFormATC = section.querySelector("#productATC");
        let timeoutId = null;

        // debounce to avoid firing on every scroll tick
        const debounce = (func, delay) => {
            return (...args) => {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => func.apply(this, args), delay);
            };
        };

        const handleScroll = debounce(() => {
            const rect = productFormATC.getBoundingClientRect();
            isVisible = rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth);

            if (isVisible) {
                productBottom.classList.remove('active');
            } else {
                productBottom.classList.add('active');
            }
        }, 0);

        window.addEventListener('scroll', handleScroll);

        section.querySelector("#productBottom").addEventListener("click", function () {
            section.querySelector("#productVendor").scrollIntoView({behavior: 'smooth'});
            section.querySelector("#productATC").click();
        });
    }

    /********************* Size Guide *********************/

    section.querySelectorAll('.openGuide').forEach(function (element) {
        element.addEventListener('click', function () {
            document.querySelector("#guide").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    });

    function closePopup() {
        document.querySelector("#guide").close();
        document.querySelector("body").classList.remove("noScroll");
    }

    document.querySelectorAll(".guideClose").forEach(function (element) {
        element.addEventListener("click", closePopup);
    });

    document.querySelector("#guide").addEventListener("click", function (e) {
        if (e.target === this) {
            closePopup();
        }
    });

    document.querySelector("#guide").addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
    });


    /********************* Pricing Request Modal *********************/

    // open the price-request modal for the current variant (price-request variants)
    async function openPricing() {
        // resolve the latest variant when the product has selectable options
        const optionsContainer = section.querySelector(".productWrap.normal");
        if (optionsContainer) {
            activeVariant = await getActiveVariant(product, optionsContainer);
        }
        if (!activeVariant) {
            return;
        }

        document.querySelector(".pricingFormTxt").textContent = `Request pricing for ${product.title} - ${activeVariant.title}`;
        document.querySelector(".pricing").showModal();
        document.querySelector("body").classList.add("noScroll");
    }

    // wire up the modal only when the section actually renders it
    const pricingDialog = document.querySelector(".pricing");
    if (pricingDialog) {

        // close the modal and restore scroll
        const closePricing = function () {
            pricingDialog.close();
            document.querySelector("body").classList.remove("noScroll");
        };

        pricingDialog.querySelectorAll(".pricingClose").forEach(function (element) {
            element.addEventListener("click", closePricing);
        });

        // close when clicking the backdrop
        pricingDialog.addEventListener("click", function (e) {
            if (e.target === this) {
                closePricing();
            }
        });

        pricingDialog.addEventListener("close", function () {
            document.querySelector("body").classList.remove("noScroll");
        });

        // submit the price request to the request-pricing endpoint
        pricingDialog.querySelector(".pricingForm").addEventListener("submit", async function (e) {
            e.preventDefault();

            pricingDialog.querySelector(".pricingFormSubmit").classList.add("loading");

            // build the payload from the form plus product context
            const formData = new FormData(this);
            formData.append("url", window.location.href);
            formData.append("product_title", product.title);
            formData.append("variant_title", activeVariant.title);
            const payload = Object.fromEntries(formData);

            const response = await fetch("https://api.audryrosejewelry.com/public/request-pricing.php", {
                method: "POST",
                body: JSON.stringify(payload),
            }).then(response => response.json());

            pricingDialog.querySelector(".pricingFormSubmit").classList.remove("loading");

            // surface any API error and bail
            if (response.error) {
                pricingDialog.querySelector(".pricingFormError").textContent = `There was an error with your request: ` + response.error;
                return;
            }

            // hide the form and show the success message
            pricingDialog.querySelector(".pricingForm").classList.remove("active");
            pricingDialog.querySelector(".pricingSuccess").classList.add("active");
        });
    }

})();